export enum BranchUserPermission {
    AccountInfoView = 'branchuser-account-info.view',
    BranchesManagementView = 'branchuser-branches-management.view',
    BranchesManagementEdit = 'branchuser-branches-management.edit',
    ReservationManagementView = 'branchuser-reservation-management.view',
    ReservationManagementEdit = 'branchuser-reservation-management.edit',
    AttendanceManagementView = 'branchuser-attendance-management.view',
    AttendanceManagementEdit = 'branchuser-attendance-management.edit',
    EvaluationManagementView = 'branchuser-evaluation-management.view',
    EvaluationManagementEdit = 'branchuser-evaluation-management.edit',
    ProgramsListView = 'branchuser-programs-list.view',
    ProgramsListEdit = 'branchuser-programs-list.edit',
}
